import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';
import { ConfigurationType, ProjectSettingService } from 'src/app/pages/projects/services/project-setting.service';
import { SettingsPageService } from '../../settings-service/settings-page.service';

@Component({
  selector: 'app-artifact-setting-modal',
  templateUrl: './artifact-setting-modal.component.html',
  styleUrls: ['./artifact-setting-modal.component.scss']
})
export class ArtifactSettingModalComponent implements OnInit, OnDestroy {

  @ViewChild("modal") modal!: ElementRef;
  @Output() updateTable: EventEmitter<any> = new EventEmitter();

  projectId: number | null = null;
  modalTitle: string;

  artifactForm!: FormGroup;
  submitted: boolean = false;
  modalRef: NgbModalRef;
  loading: boolean = true;

  constructor(protected settingSrv: SettingsPageService,
    protected projSettingSrv: ProjectSettingService,
    protected modalService: NgbModal,
    protected fb: FormBuilder,
    public translateService: TranslateService,
    protected utilSrv: UtilsService) { }

  ngOnInit(): void {
    this.setForm();
  }

  ngOnDestroy(): void {
    this.projectId = null;
    this.modalTitle = '';
    this.submitted = false;
    this.loading = false;
  }

  get formArtifact() { return this.artifactForm.controls; }

  setForm() {
    this.artifactForm = this.fb.group({
      typeEN: ['', Validators.required],
      customerTypeEN: ['', Validators.required],
      id: [0],
    });
  }

  openModal( type: string, data: any, projectId?: number) {
    this.loading = true;
    this.setForm();
    if (projectId) this.projectId = projectId;
    this.modalTitle = type === 'editArtifact' ? 'SETTINGS.ARTIFACTS.EDITTYPE' : 'SETTINGS.ARTIFACTS.ADDTYPE';

    if (type === 'editArtifact') this.fillForm(data);
    else this.loading = false;
    this.modalRef = this.modalService.open(this.modal, { centered: true, backdrop: 'static', keyboard: false });
  }

  fillForm(data: any) {
      this.artifactForm.controls['id'].setValue(data.id);
      this.artifactForm.controls['customerTypeEN'].setValue(data.clientDescription);
      this.artifactForm.controls['typeEN'].setValue(data.description);

      this.loading = false;
  }

  save() {
    this.submitted = true;
    if (this.artifactForm.valid) {
      const data: any = {
        type: ConfigurationType.ARTIFACT,
        description: this.formArtifact.typeEN.value,
        clientDescription: this.formArtifact.customerTypeEN.value,
      };


      if (this.projectId) {
        data['projectId'] = this.projectId;
      }

      const id = this.formArtifact.id.value;
      let request;
      if (this.projectId) {
        request = id === 0 ? this.projSettingSrv.createConfig(this.projectId, data) : this.projSettingSrv.updateConfig(this.projectId, id, data);
      } else request = id === 0 ? this.settingSrv.registerConfigurations(data) : this.settingSrv.updateConfiguration(data, id);

      request.pipe().subscribe((data: any) => {
        const successMsg = id === 0 ? 'SETTINGS.CREATED' : 'SETTINGS.UPDATED';
        this.utilSrv.notify(successMsg, 'success').then(() => {
          this.updateTable.emit();
          this.closeModal();
        });
      }, (error: any) => {
        console.error('Save', error);
        this.utilSrv.notify('SETTINGS.ERROR', 'error');
      });
    }
  }

  closeModal() {
    this.submitted = false;
    this.artifactForm.reset();
    this.modalRef.close();
  }

}
